import React, {
  createContext,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { SCANSTATUS, CONNECTSTATUS, PubSubEnum } from '../config';
import pubSubInstance from '../../../../shared/utils/pubSub';

export const CheckScannerContext = createContext(null);

export const CheckScannerProvider = ({ children, value }) => {
  const [ scanInfo, setScanInfo ] = useState({
    scannedCheckNumber: '',
    frontImage: '',
    backImage: '',
    bankNumber: '',
    checkCountry: '',
    micrCheckNumber: '',
    accountNumber: '',
    routingNumber: '',
    checkType: '',
    micrRaw: '',
    scanStatus: SCANSTATUS.init,
  });
  const [ status, setStatus ] = useState(CONNECTSTATUS.init);

  const [ showModal, setShowModal ] = useState(false);

  const [ errorInfo, setErrorInfo ] = useState({
    show: false,
    text: '',
  });

  const [ showImageModal, setShowImageModal ] = useState(false);

  const showImageModalHandler = useCallback((params) => {
    const backImage = params.backImage || scanInfo.backImage;
    const frontImage = params.frontImage || scanInfo.frontImage;
    setScanInfo({
      ...scanInfo,
      backImage,
      frontImage,
    });
    setShowImageModal(true);
  }, [ scanInfo ]);

  useEffect(() => {
    pubSubInstance.subscribe(PubSubEnum.CheckScannerShowImageModal, showImageModalHandler);
    return () => {
      pubSubInstance.unsubscribe(PubSubEnum.CheckScannerShowImageModal, showImageModalHandler);
    };
  }, [ showImageModalHandler ]);

  return (
    <CheckScannerContext.Provider
      value={{
        status,
        setStatus,
        scanInfo,
        setScanInfo,
        showModal,
        setShowModal,
        errorInfo,
        setErrorInfo,
        showImageModal,
        setShowImageModal,
        ...value,
      }}>
      {children}
    </CheckScannerContext.Provider>
  );
};
